import redFlad from 'app/images/red-flag.png';
import pqIcon from 'app/images/pq-icon.png';

const formula = {
  intro: {
    headline: 'Our Formula',
  },
  copyBlockOne: {
    headline:
      'Prick Predictor is a proprietary framework developed specifically for detecting Pricks.',
    copy:
      'Rooted in psychology, neuroscience and evolutionary biology, our framework is meant to increase your odds for a successful relationship. We predict foundational characteristics that are necessary in a healthy long term partner. We don’t predict attraction, chemistry, likes and dislikes that may also affect a relationship.',
  },
  copyBlockTwo: {
    image: {
      alt: 'alt tag',
      src: redFlad,
    },
    headline:
      'Prick Predictor’s results are best if taken 3-6 months into a relationship.',
    copy:
      'Red Flags are usually present by this time, although many women don’t pay attention because they want the relationship to work. If your relationship is younger than three months, we recommend re-taking at six months.',
  },
  copyBlockThree: {
    image: {
      alt: 'alt tag',
      src: pqIcon,
    },
    headline: 'What is a PQ score?',
    copy:
      'Just like an “IQ,” a Prick Quotient provides a number that indicates a person’s prick level. The higher the score, the higher the chance you’re dealing with a prick. The scale is weighted 0-100% chance. ',
  },
  ListBlockOne: {
    headline: 'What do we know about Pricks? ',
    listItems: [
      'Some are born Pricks, others are self-taught. Many are overachievers and manage to be both.',
      'Pricks run on patterns. We’ve decoded them and identified four distinct species of Prick.',
      'Prickness starts as a whisper... barely noticeable quirks that later scream “Run!” We help you catch the red flags while they’re still pastel.',
      'Pricks are masters of illusion. They’ll either hide their bad behavior or convince you <em>you’re</em> the problem. We call BS... loudly and clearly.',
      'Pricks target women they think they can manipulate. We’re here to make sure you’re not one of them.',
      'Our method gives you the clarity and confidence to walk away before the real damage begins. Yes, it might sting... but not as much as two decades of gaslighting and birthdayless anniversaries. Be bold. Your future self (and therapist) will thank you.',
    ],
  },
  copyBlockFour: {
    headline: 'How does it work? ',
    copy:
      '<p>The Prick Framework analyzes partners based on 4 categories.</p><p>These 4 categories construct the foundation of all relationships. We can predict the health and longevity of your relationship based on these foundational principles. Our goal is to increase the likelihood of healthy relationships by helping women say “no” to Pricks and <strong>“yes” to Good Guys.</strong></p>',
  },
  barCharts: {
    copy:
      'Note: Prick composition can vary, but the basic ingredients are constant.',
    data: [
      {
        title: 'Boundaries',
        value: 80,
      },
      {
        title: 'Availability',
        value: 30,
      },
      {
        title: 'Stability',
        value: 60,
      },
      {
        title: 'Kindness',
        value: 15,
      },
    ],
  },
  bannerText: 'Achtung:',
};

export default formula;



// WEBPACK FOOTER //
// ./src/locales/formula.js